import { Link } from "react-router-dom";
import empowernigerialogo from './empowernigerialogo.png';


function Header() {
    return (
        <>
      <div class="container">
          
          <nav class="navbar navbar-expand-md bg-success navbar-dark fixed-top">
  
    <a class="navbar-brand" href="#"><img src={empowernigerialogo} style={{height: 60}}/> Nigeria Youths</a>
  
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar">
      <span class="navbar-toggler-icon"></span>
    </button>
  
    <div class="collapse navbar-collapse" id="collapsibleNavbar">
      <ul class="navbar-nav">
        <li class="nav-item" >
          <a class="nav-link" href="/">Home</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/validate-mobile">Apply</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/check-status">Check Status</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="/about">About</a>
        </li>
      </ul>
    </div>
  </nav>
  
  
  
  </div>
 
  
 
  
 
  </>
    );
  }

  export default Header